import { Stack, Text, Group, Paper, Divider } from '@mantine/core';
import { IconUser, IconCalendar } from '@tabler/icons-react';
import Dates from 'components/Dates';
import React from 'react';

interface BasicPlanInformationProps {
  planningData: {
    planningName: string;
    programType: string;
    planningDescription: string;
    userIn: string;
    dateIn: string;
    userUp?: string | null;
    dateUp?: string | null;
  };
}

const BasicPlanInformationSection: React.FC<BasicPlanInformationProps> = ({ planningData }) => {
  return (
    <Paper withBorder p={20} radius='lg'>
      <Stack gap={16}>
        <Text fw={600} size='lg'>
          Basic Plan Information
        </Text>

        <Stack gap={12}>
          <div>
            <Text size='sm' fw={500} c='dimmed' mb={4}>
              Plan Name
            </Text>
            <Text size='sm'>{planningData.planningName}</Text>
          </div>

          <div>
            <Text size='sm' fw={500} c='dimmed' mb={4}>
              Program Type
            </Text>
            <Text size='sm' tt='capitalize'>
              {planningData.programType}
            </Text>
          </div>

          <div>
            <Text size='sm' fw={500} c='dimmed' mb={4}>
              Description
            </Text>
            <Text size='sm'>{planningData.planningDescription || 'No description provided'}</Text>
          </div>
        </Stack>

        <Divider />

        <Group gap={24}>
          <Group gap={8}>
            <IconUser size={16} color='gray' />
            <div>
              <Text size='xs' c='dimmed'>
                Created by
              </Text>
              <Text size='sm' fw={500}>
                {planningData.userIn}
              </Text>
              <Text size='xs' c='dimmed'>
                <Dates date={planningData.dateIn} fz={11} />
              </Text>
            </div>
          </Group>

          {planningData.userUp && planningData.dateUp && (
            <Group gap={8}>
              <IconCalendar size={16} color='gray' />
              <div>
                <Text size='xs' c='dimmed'>
                  Last updated by
                </Text>
                <Text size='sm' fw={500}>
                  {planningData.userUp}
                </Text>
                <Text size='xs' c='dimmed'>
                  <Dates date={planningData.dateUp} fz={11} />
                </Text>
              </div>
            </Group>
          )}
        </Group>
      </Stack>
    </Paper>
  );
};

export default BasicPlanInformationSection;
